module.exports = __webpack_public_path__ + "static/media/layout-7.9c413749.svg";